import { useEffect, useState, useContext } from 'react';
import { CircularProgress } from '@mui/material';
import { Context } from '../../../AuthContext';
import NewRefreshResultsModal from './NewRefreshResultsModal';

const isVisibleRow = (r) =>
  r.status === 'Created' || (r.status === 'Joined' && r.permission === 'AdvancedEditor');

const DiscoveryRefreshesSummary = () => {
  const { user } = useContext(Context);
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pendingRows, setPendingRows] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, [user?.uid]);

  const fetchData = async () => {
    if (!user?.uid) return;
    setLoading(true);
    try {
      const token = await user.getIdToken();
      const headers = { Authorization: `Bearer ${token}` };
      const [stateRes, pendingRes] = await Promise.all([
        fetch(process.env.REACT_APP_FLASK_WEBSERVER + 'refresh_state', { headers }),
        fetch(process.env.REACT_APP_FLASK_WEBSERVER + 'pending_refresh_counts', { headers }),
      ]);
      if (stateRes.ok) setState(await stateRes.json());
      if (pendingRes.ok) setPendingRows(await pendingRes.json());
    } catch (err) {
      console.error('Failed to fetch refresh data', err);
    } finally {
      setLoading(false);
    }
  };

  const remaining = state ? Math.max(state.limit - state.used, 0) : 0;
  const visibleRows = pendingRows.filter(isVisibleRow);
  const hasPending = visibleRows.length > 0;

  return (
    <div
      style={{
        padding: '12px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '12px',
          fontWeight: 600,
          minWidth: 0,
        }}
      >
        <img src="/refresh.svg" alt="" style={{ height: '24px', width: '24px', flexShrink: 0 }} />
        <span
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
          }}
        >
          DISCOVERY REFRESHES
        </span>
      </div>
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {loading ? (
          <CircularProgress size={24} style={{ color: '#000' }} />
        ) : state ? (
          <>
            <div
              style={{
                color: '#1976d2',
                fontSize: '14px',
                fontWeight: 700,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
              }}
            >
              REFRESHES REMAINING
            </div>
            <div style={{ fontSize: '32px', fontWeight: 700 }}>{remaining}</div>
            <div style={{ fontSize: '14px' }}>This Month</div>
            {state.days_until_reset != null && (
              <div style={{ fontSize: '14px' }}>
                (Resets in {state.days_until_reset} {state.days_until_reset === 1 ? 'Day' : 'Days'})
              </div>
            )}
          </>
        ) : null}
      </div>
      {!loading && state && hasPending && (
        <div
          onClick={() => setModalOpen(true)}
          style={{
            color: '#1976d2',
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: 700,
            textDecoration: 'underline',
            cursor: 'pointer',
            marginBottom: '12px',
          }}
        >
          New Results Available!
        </div>
      )}
      <NewRefreshResultsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        rows={visibleRows}
      />
    </div>
  );
};
export default DiscoveryRefreshesSummary;
